import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {PAGE_CATEGORY} from "@constants"
import { pageCategory } from "@signals"

const OPTIONS = [
    { label: "Mono Brand", value: PAGE_CATEGORY.MONO_BRAND },
    { label: "Multi Company", value: PAGE_CATEGORY.MULTI_COMPANY },
    { label: "Editorial", value: PAGE_CATEGORY.EDITORIAL },
    { label: "Promotion", value: PAGE_CATEGORY.PROMOTION },
    { label: "Others", value: PAGE_CATEGORY.OTHERS },
    { label: "Brand Logo", value: PAGE_CATEGORY.BRAND_LOGO },
    { label: "Mono Company", value: PAGE_CATEGORY.MONO_COMPANY }
]


export default function DIPageCategorySelect({ ...props }) {
    return <SelectSeeker
        multiple
        isClearable
        options={OPTIONS}
        label="Page Categories"
        value={pageCategory.value}
        placeholder="All pages category"
        onChange={e => pageCategory.value = e.target.value}
        {...props}
    />
}